import { Phone } from "lucide-react";

export default function CallButton() {
  return (
    <a
      href="tel:+302105719375"
      data-testid="floating-call-button"
      aria-label="Καλέστε μας: 210 571 9375"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute -top-10 right-0 whitespace-nowrap bg-white border-2 border-dashed border-brand-primary rounded-2xl px-3 py-1 font-hand text-lg text-brand-text opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-md pointer-events-none">
        Καλέστε μας!
      </span>
      <span className="relative flex items-center justify-center w-16 h-16 rounded-full bg-brand-primary border-3 border-dashed border-white shadow-[0_6px_0_-2px_rgba(91,79,70,0.3)] hover:scale-110 transition-transform duration-300">
        <span className="absolute inline-flex h-full w-full rounded-full bg-brand-primary opacity-40 animate-ping" style={{ animationDuration: "2.5s" }} />
        <Phone className="relative text-white" size={28} strokeWidth={2.4} />
      </span>
    </a>
  );
}
